import { BannerStatus } from './Banner';
import { colors, semantic_colors } from '../../foundation';

export const banner_color_css: Record<BannerStatus, string> = {
  neutral: semantic_colors.content.primary,
  error: semantic_colors.state.negative,
  info: semantic_colors.accent.primary,
  success: semantic_colors.state.positive,
  warning: semantic_colors.state.warning,
};

export const banner_background_color_css: Record<BannerStatus, string> = {
  neutral: colors.gray10,
  error: semantic_colors.state.negative_light,
  info: semantic_colors.accent.light,
  success: semantic_colors.state.positive_light,
  warning: semantic_colors.state.warning_light,
};

export const banner_border_color_css: Record<BannerStatus, string> = {
  neutral: semantic_colors.border.secondary,
  error: colors.red150,
  info: colors.blue300,
  success: colors.green300,
  warning: colors.orange200,
};
